/* Карточка-герой с листком календаря (вариант G). */
.hero {
  padding: 18px var(--pad) var(--pad);
  color: var(--hero-fg);
  background: var(--hero-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--r-xl);
  box-shadow: var(--shadow-float);
}

.row {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Листок календаря: шапка с месяцем, ниже число. */
.sheet {
  flex: 0 0 auto;
  width: 84px;
  overflow: hidden;
  text-align: center;
  border: 1px solid rgb(255 255 255 / 14%);
  border-radius: 16px;
}

.month {
  padding: 4px 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #111;
  /* Цвет шапки — тон состояния: зелёный, оранжевый, красный. Листок
     сам по себе сообщает срочность, ещё до того как прочитан текст. */
  background: var(--sheet-tone, var(--ink));
}

.day {
  padding: 6px 0 8px;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.text {
  min-width: 0;
}

.title {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.25;
}

.sub {
  margin-top: 2px;
  font-size: 13px;
  color: var(--hero-dim);
}

.actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
}

/* Срок прошёл: дата перечёркнута, а не просто показана. */
.past {
  color: var(--hero-dim);
  text-decoration: line-through;
  text-decoration-thickness: 3px;
}

/* Подписки не было: пустой листок. */
.empty {
  color: var(--hero-dim);
}
